import resourceService from './resource_service';

const modelName = 'dispense-log';

const attributes = {
  loginTime: '',
  startTime: '',
  stopTime: '',
  errorCode: '',
  totalWeight: '',
  actualVolume: '',
  actualWeight: '',
  targetVolume: '',
  errorMessage: '',
};

const relationships = {
  app: {
    jsonApi: 'hasOne',
  },
  plantUser: {
    jsonApi: 'hasOne',
  },
  unit: {
    jsonApi: 'hasOne',
  },
  dispenseSteps: {
    jsonApi: 'hasMany',
  },
};

export default resourceService(modelName, attributes, relationships);
